module.exports = __webpack_public_path__ + "media/images/abstract-bad-2904ad905c9187eb5636d5efacda881c.png";